const getters = {
  listaItensGlossario: (state) => state.listaItensGlossario,
  dialogEdicao: (state) => state.dialogEdicao,
  listaTiposDocumento: (state) => state.listaTiposDocumento
}

export default getters
